
import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Input, Select, Form, message, InputNumber, AutoComplete } from 'antd';
import { layout } from '../../commonImports/import1'
import moment from 'moment'
import SelectWithFetch from '../../common/selectWithFetch';
import { withApollo } from 'react-apollo';
import { roaData, frequencyList, dosageUnit } from '../../commonImports/data'
import { searchGlobalMedication } from '../../../graphql/queries';

const dateFormat = 'YYYY-MM-DD';

let todayDate = moment().format(dateFormat)

const { Option } = Select;


const MedicationsAddForm = (props) => {

  const [form] = Form.useForm();

  const [data, setdata] = useState([])
  const [searchResults, setsearchResults] = useState([]);
  const [selected, setselected] = useState(null);
  const [globalEnabled, setglobalEnabled] = useState(false);
  const [enddate, setenddate] = useState(todayDate);
  const [duration, setduration] = useState(null)
  const [loading, setloading] = useState(false)
  const [initialValues, setinitialValues] = useState({})
  const [groupedSearchResults, setgroupedSearchResults] = useState([])



  useEffect(() => {
    let data = props.data != null && props.data.length > 0 ?
      props.data.map((a, i) => {
        return a
      }) : []
    setdata(data)
  }, [props.data])


  useEffect(() => {
    if(props.record && props.record != null){
      setinitialValues({...props.record})
      form.setFieldsValue({
        ...props.record,
        // dosageDate : [moment(props.record.dosageDate[0]), moment(props.record.dosageDate[1])],
        dosage: props.record.dosage ? parseInt(props.record.dosage) : undefined
      })
  
      setduration(props.record.duration)
      setselected({
        medicationName: props.record.brandName,
        genericName: props.record.genericName,
  
      })

    }
  }, [props.record])


  const onFinish = (values) => {
    let obj = {...values};
    if(props.setMainData){
      props.setMainData(obj)
    }

    // form.resetFields()
    form.setFieldsValue({
      dosageDate : [moment(), moment()],
      brandName: undefined,
      genericName: undefined,
      frequency: undefined,
      dosage: undefined,
      dosageUnit: undefined,
      roa: undefined,
      instruction: undefined,
      duration:undefined
    })

    setselected(null)
    message.success('Medication added successfully')
    setsearchResults([])
    setduration(null)
  }



  const handleFetchData=(val)=>{
    setloading(true)
      props.client.query({
        query: searchGlobalMedication,
        variables:{
          searchValue: val,
          from:0,
          size:100
        },
      }).then((data)=>{
       if(data.data.searchGlobalMedication){
        setdata(data.data.searchGlobalMedication)
        let obj = new Object();
        let arr = []
        let res = data.data.searchGlobalMedication;
        res.map((a) => {
          if (obj.hasOwnProperty(a.genericName)) {

            obj[a.genericName].push(a);
            let index = arr.findIndex((item) => item.label == a.genericName);
            let item = arr[index];
  
            if (item) {
              a.label=a.medicationName;
              a.key=a.id;
              a.value=a.medicationName;
              item.options.push(a)
              arr.splice(index, 1, item)
            }
          } else {
            a.label=a.medicationName;
            a.key=a.id;
            a.value=a.medicationName;
            obj[a.genericName] = [a];
            let obj1 = {
              label : 'Default'+' - '+a.genericName,
              key : a.genericName,
              value: a.genericName,
              genericName: a.genericName

            }
            
            arr.push({
              label: a.genericName,
              options: [obj1, a]
            })
          }
        })
        setgroupedSearchResults(arr)
       }
       setloading(false)
      }).catch((err)=>{
       console.log(err)
       setloading(false)
      })
  }

  // const onDurationChange = (val) => {
  //   if (val != null && val > 0) {
  //     let end = moment().add(val - 1, 'days')
  //     let dd = moment(end).format(dateFormat);
  //     setduration(val)
  //     if (dd.includes('-')) {
  //       setenddate(dd)
  //       form.setFieldsValue({
  //         dosageDate: [moment(todayDate, dateFormat), moment(dd, dateFormat)]
  //       })
  //     }
  //   } else {
  //     form.setFieldsValue({
  //       dosageDate: [moment(todayDate, dateFormat), moment(todayDate, dateFormat)]
  //     })
  //   }
  // }


  // const onChangeDate = (data, type) => {
  //   let days = Math.round((data[1] - data[0]) / (1000 * 60 * 60 * 24));
  //   setduration(moment(data[1]).diff(data[0],'days'))
  // }


  const renderSearchComp = (type) => {
    let arr = []
    if(type=='medicationName'){
      arr.push({
        title: null,
        val: 'medicationName'
      })
    }
    if(type=='genericName'){
      arr.push({
        title: null,
        val: 'genericName'
      })
    }

    return(
      <AutoComplete style={{ width: '100%' }}
      options={groupedSearchResults}
      onSearch={(res)=>{
        handleFetchData(res)
      }}
      onSelect={(res, option) => {
        let item = data.find((a)=>a.id == option.id)
        if(item){
          setselected(item)
          form.setFieldsValue({
            brandName: item['medicationName'],
            genericName: item['genericName']
          })
        }else{
          setselected(option)
          form.setFieldsValue({
            brandName: undefined,
            genericName: option['genericName']
          })
        }
      }}
      filterOption={(input, option) =>{
        return true
        // return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
       }}
    >
      <Input.Search placeholder="Select Response" />
    </AutoComplete>
    )
    
    return (
      <SelectWithFetch
        selected={selected}
        custVal={selected != undefined && selected != null ?
          {
            key: selected.id,
            label: selected.medicationName + ' ' + selected.genericName,
            value: selected.id
          }
          : null}
        dropDownEnabled={globalEnabled == false ? true : false}
        dropDownComp={<>
        </>}
        form={form}
        placeholder={'Search Medication'}
        handleSearch={(val) => {
          handleFetchData(val)
        }}
        data={data}
        alter={true}
        keyName={'id'}
        fields={arr}
        setSelectedResult={(val) => {
          let item = data.find((a)=>a.id == val.value)

          if(item){
            setselected(item)
            form.setFieldsValue({
              brandName: item['medicationName'],
              genericName: item['genericName']
            })
          }
        }}
      />
    )
  }

  return (
    <div>
      <Form
        form={form}
        {...layout}
        name="basic"
        // initialValues={}
        initialValues={initialValues}
        onFinish={onFinish}
      >
        <Row gutter={24}>
       
            <Form.Item
              label="Brand Name"
              name="brandName"
              noStyle
              rules={[{ required: false, message: 'Please input Brand Name!' }]}
            >
          
            </Form.Item>
         
          <Col span={24}>
            <Form.Item
              label="Generic Name"
              name="genericName"
              rules={[{ required: true, message: 'Please input Generic Name!' }]}
            >
              {/* <Input placeholder="Generic Name"/> */}
              {renderSearchComp('genericName')}
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              label="Frequency"
              name="frequency"
              rules={[{ required: false, message: 'Please input Frequency!' }]}
            >
              <Select placeholder="Frequency" >
                {frequencyList.map((item) => {
                  return (
                    <Option value={item.name}>{item.name}</Option>
                  )
                })}
              </Select>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              label="Quantity per dose"
              name="dosage"
              rules={[{ required: false, message: 'Please input Dosage!' }]}
            >
              <Input placeholder="Dosage" />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              label="Dosage Unit"
              name="dosageUnit"
              rules={[{ required: false, message: 'Please input Dosage Unit!' }]}
            >
              <Select placeholder="Unit" >
                {dosageUnit.map((item) => {
                  return (
                    <Option value={item}>{item}</Option>
                  )
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
          <Form.Item
              label="ROA"
              name="roa"
              rules={[{ required: false, message: 'Please input ROA!' }]}
            >

            <Select placeholder="ROA" style={{ width: '100%' }} >
              {roaData.map((item) => {
                return (
                  <Option value={item.desc}>{item.desc}</Option>
                )
              })}
            </Select>
            </Form.Item>
         

          </Col>
          <Col span={8}>
          <Form.Item
              label="Instructions"
              name="instruction"
              rules={[{ required: false, message: 'Please input Instructions.' }]}
            >

              <Input.TextArea placeholder="Instructions" style={{ width: '100%' }} />
              </Form.Item>
       </Col>

       
          <Col span={8}>
       
            <Form.Item
              label="Duration in Days"
              name="duration"
              rules={[{ required: false, message: 'Please input Duration.' }]}
            >
            <InputNumber min={0} placeholder="Duration" style={{ width: '100%' }} />
          </Form.Item>
          </Col>
          {/* <Col span={8}>
            <Form.Item
              label="Dosage Date"
              name="dosageDate"
              rules={[{ required: false, message: 'Please input your username!' }]}
            >
              <DatePicker.RangePicker
                // defaultValue={[moment(todayDate, dateFormat), moment(enddate, dateFormat)]}
                onChange={onChangeDate}
              />
            </Form.Item>
          </Col> */}
          <Col span={24} >
            {/* <Button style={{ float: 'right' }}
              // type={"primary"}
              onClick={() => {
                form.resetFields()
                setselected(null)
                setsearchResults([])

              }}><RedoOutlined /> Reset
              </Button> */}
            <Button id='addGeneric' style={{ float: 'right', marginRight: '5px' }} type="primary" htmlType="submit">{ props.record ? 'Update' : 'Add'}</Button>
            <div style={{ float: 'right', marginRight: '15px' }}>

            </div>

          </Col>

        </Row>
      </Form>




      {/* <Table size="small" columns={columns} dataSource={data} pagination={false} /> */}
      {/* <Form.Item
      name="medication"
     >

     </Form.Item> */}
    </div>
  )
}

export default withApollo(MedicationsAddForm)